/**
 * Given a hierarchy item, retrieve its cover photo
 *
 * @param {Object} hierarchyItem The hierarchy item
 * @returns {Object} a cover photo (if available)
 */
export const getHierarchyItemCoverPhoto = hierarchyItem => {
  return (
    hierarchyItem?.cover_photo ??
    hierarchyItem?.main_cover_photo?.records?.[0] ??
    hierarchyItem?.cover_photos?.records?.[0] ??
    hierarchyItem?.matched_photos_extended?.records?.[0]?.photo
  );
};

/**
 * Given entitledPurchases and a photo, determine if the photo has been purchased
 *
 * @param {Array} entitledPurchases the entitled purchases, an array of photo ids
 * @param {Object} photo the photo to check for face blocking
 * @param {Boolean} isPictureDay whether the albumFolder is PD or not
 * @param {isWebGallery} isWebGallery whether the albumFolder is web gallery or not
 * @returns {Boolean}
 */
export const shouldFaceblock = (
  entitledPurchases,
  photo,
  isPictureDay,
  isWebGallery,
) => {
  if (!isPictureDay || !photo) {
    return false;
  }

  if (isWebGallery) {
    // Picture day + FWG is not really a supported case overall,
    // so when landing on these cases, where hierarchy view is available
    // we'll avoid faceblocking items.
    return false;
  }

  return !entitledPurchases.includes(photo.id);
};
